import React, { useEffect } from "react";
import styles from "./IndividualService.module.css";
import { useLocation } from "react-router-dom";
import data from "./data";

const IndividualService = () => {
  const { search } = useLocation();

  const id = parseInt(new URLSearchParams(search).get("id"));
  const service = data.find((x) => x.id === id);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [id]);

  if (!service) return <p>Service not found</p>;

  return (
    <div className={`container ${styles.container}`}>

      {/* MAIN HEADING */}

      {/* INTRO */}
      <p className={styles.intro}>{service.content}</p>

      {/* SECTIONS */}
      {service.contents.map((x, idx) => (
        <div key={idx} className={styles.section}>

          {/* FLOAT IMAGE */}
          <img src={x.img} alt="" className={styles.floatImage} />

          {/* TITLE */}
          <h2 className={styles.subHeading}>{x.heading}</h2>

          {/* CONTENT */}
          <div
            className={styles.blogContent}
            dangerouslySetInnerHTML={{ __html: x.content }}
          />

          {/* CLEAR FLOAT */}
          <div style={{ clear: "both" }} />
        </div>
      ))}
    </div>
  );
};

export default IndividualService;